var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2cda934ffed0eafc87debf7571fdcbee6aa3b472"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mypage@inditidual"]={id:"2cda934ffed0eafc87debf7571fdcbee6aa3b472"};
      